import { useIsMounted, useUnmountEffect } from "@react-hookz/web";
import { useRef, useCallback } from "react";
export const useRequestAnimationFrame = () => {
  const rafIdRef = useRef(0);
  const cancel = useCallback(() => {
    cancelAnimationFrame(rafIdRef.current);
  }, []);
  const isMounted = useIsMounted();
  const raf = useCallback(callback => {
    cancel();
    rafIdRef.current = requestAnimationFrame(() => {
      if (isMounted()) {
        callback();
      }
    });
  }, [isMounted, cancel]);
  useUnmountEffect(cancel);
  return {
    cancel,
    raf
  };
};
//# sourceMappingURL=useRequestAnimationFrame.js.map